import React from 'react';
import { Link } from '@inertiajs/react';
import { useTrans } from '../../../hooks/useTrans';
import CustomerServiceContact from './CustomerServiceContact';

export default function AuthCard({ title, children, backLink }) {
    const translate = useTrans();

    return (
        <>
            <div className="w-full max-w-[400px] mx-auto rounded-[3px] border border-[#bbb] bg-white">
                <div className="p-[30px]">
                    <div className="flex flex-col gap-8">
                        <div className="space-y-4">
                            <header>
                                <span className="text-xl font-bold text-[#003545]">{title}</span>
                            </header>
                            <hr className="border-[#dfdfdf]" />
                            <div className="text-[14px] text-[#003545] [&_p]:mb-0 [&_li]:mb-0 [&_ol]:mt-2 [&_ol]:mb-2 [&_ul]:mt-2 [&_ul]:mb-2">
                                {children}
                            </div>
                            <hr className="border-[#dfdfdf] mt-6" />
                            <CustomerServiceContact />
                        </div>
                    </div>
                </div>
            </div>
            {backLink && (
                <div className="text-center mt-4">
                    <Link href={backLink} className="text-sm text-white/60 hover:text-white no-underline">
                        {translate('Terug')}
                    </Link>
                </div>
            )}
        </>
    );
}
